import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-shopping-cart" }, null, -1)
const _hoisted_2 = { class: "p-ml-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-shopping-bag" }, null, -1)
const _hoisted_4 = { class: "p-ml-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus-circle" }, null, -1)
const _hoisted_6 = { class: "p-ml-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-minus-circle" }, null, -1)
const _hoisted_8 = { class: "p-ml-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bookmark-fill" }, null, -1)
const _hoisted_10 = { class: "p-ml-2" }

import { computed, ref } from "vue";
import StockIndividual from "../../components/stock/StockIndividual.vue";
import Inventory from "../../components/stock/Inventory.vue";
import Document from "../../components/document/Document.vue";
import { useProducts } from "@/graphql/product/products";
import { useFindAllCategories } from "@/graphql/category/find.all.categories";
import StockIn from "@/components/stock/StockIn.vue";

const ACTIVE_INDEX = "STOCK_ACTIVE_INDEX";

export default /*#__PURE__*/_defineComponent({
  __name: 'Stock',
  setup(__props) {

const savedIndex = sessionStorage.getItem(ACTIVE_INDEX);
const active = ref(parseInt(savedIndex || "0"));
function saveActive(index: number) {
  sessionStorage.setItem(ACTIVE_INDEX, String(index));
}
const { loading: loadingProduct, products } = useProducts();
const { loading: loadingCategory, categories } = useFindAllCategories();
const loading = computed(() => loadingProduct.value || loadingCategory.value);

return (_ctx: any,_cache: any) => {
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createBlock(_component_TabView, {
    lazy: "",
    "active-index": active.value,
    "onUpdate:activeIndex": [
      _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
      saveActive
    ]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_TabPanel, null, {
        header: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("stock.byProduct")), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(StockIndividual, {
            loading: loading.value,
            products: _unref(products),
            categories: _unref(categories)
          }, null, 8, ["loading", "products", "categories"])
        ]),
        _: 1
      }),
      _createVNode(_component_TabPanel, null, {
        header: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("stock.inventory")), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(Inventory, {
            loading: loading.value,
            products: _unref(products),
            categories: _unref(categories)
          }, null, 8, ["loading", "products", "categories"])
        ]),
        _: 1
      }),
      _createVNode(_component_TabPanel, null, {
        header: _withCtx(() => [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("stock.entry")), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(StockIn, {
            type: 3,
            loading: loading.value,
            products: _unref(products),
            categories: _unref(categories)
          }, null, 8, ["loading", "products", "categories"])
        ]),
        _: 1
      }),
      _createVNode(_component_TabPanel, null, {
        header: _withCtx(() => [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("stock.out")), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(StockIn, {
            type: 4,
            loading: loading.value,
            products: _unref(products),
            categories: _unref(categories)
          }, null, 8, ["loading", "products", "categories"])
        ]),
        _: 1
      }),
      _createVNode(_component_TabPanel, null, {
        header: _withCtx(() => [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("stock.documents")), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(Document)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["active-index"]))
}
}

})